import { env } from './env';

export const isProduction = env.PUBLIC_ENVIRONMENT === 'production';
export const isLocal = env.PUBLIC_ENVIRONMENT === 'local';
